import { Component } from '@angular/core';

@Component({
  selector: 'app-workbench-footer',
  templateUrl: './workbench-footer.component.html',
  styleUrls: ['./workbench-footer.component.scss'],
  standalone: false
})
export class WorkbenchFooterComponent {}
